import React, {useEffect, useRef, useState} from "react";
import "./css/Demerger.css";
import {useRefreshContext} from "../context/RefreshContext"; // Import the separate CSS file
import {deleteContractNote, fetchManualContractNoteNo, saveContractNote} from "@portfolio/utils/PFService"; // Import the new CSS file
import { usePopupStack } from "../../contexts/PopupStackContext";

const Demerger = ({symbol, totalQuantity, totalAmount, onClose, onSave, isDisplayClick, contractNoteDTO, clientId}) => {
    const [date, setDate] = useState(new Date().toISOString().split("T")[0]); // Default to today
    const formRef = useRef(null);
    const {refreshPFdata} = useRefreshContext(); // 🔹 Subscribe to global refresh
    const [demergedInto, setDemergedInto] = useState([]); // Store multiple demerged rows
    const [beforeDemergerQuantity, setBeforeDemergerQuantity] = useState(0);
    const [beforeDemergerTotalAmount, setBeforeDemergerTotalAmount] = useState(0);
    const [demergedCompany, setDemergedCompany] = useState(null);
    const { push, pop } = usePopupStack();

    useEffect(() => {
        if (isDisplayClick) {
            /* setQuantity(contractNoteDTO.transactions[0].quantity);
             setNarration(contractNoteDTO.transactions[0].narration);
             setDemergedInto([{ script: contractNoteDTO.transactions[0].script, quantity: contractNoteDTO.transactions[0].quantity, totalAmount: contractNoteDTO.transactions[0].totalAmount }]); // Wrap in an array*/
            const demergedIntoLocal = contractNoteDTO.transactions.map(transaction => ({
                script: transaction.symbol,   // ✅ Assign symbol to script
                quantity: transaction.netQuantity,  // ✅ Assign quantity
                totalAmount: transaction.totalValue  // ✅ Assign totalValue to totalAmount
            }));
            setDemergedInto(demergedIntoLocal);
            setBeforeDemergerQuantity(contractNoteDTO.transactions[0].demergerDetails.beforeDemergerQuantity);
            setBeforeDemergerTotalAmount(contractNoteDTO.transactions[0].demergerDetails.beforeDemergerTotalAmount);
            setDemergedCompany(contractNoteDTO.transactions[0].demergerDetails.demergedFromSymbol);
        } else {
            setDemergedInto([{script: symbol, quantity: totalQuantity, totalAmount: totalAmount}]); // Wrap in an array
            setBeforeDemergerQuantity(totalQuantity);
            setBeforeDemergerTotalAmount(totalAmount);
            setDemergedCompany(symbol);
        }
    }, []); // Added dependencies

    useEffect(() => {
        const popupEntry = { onClose }; // 🔥 Use the prop directly
        push(popupEntry);
        return () => pop();
    }, []);

    const handleClose = () => {
        pop(); // 🧹 Make sure to remove this popup from the stack manually
        onClose();
    };

    const handleSave = async () => {

        // Validation check
        for (let i = 0; i < demergedInto.length; i++) {
            const txn = demergedInto[i];

            if (typeof txn.script !== "string" || txn.script.trim() === "") {
                alert(`Row ${i + 1}: Script Name must be a valid string.`);
                return;
            }

            if (typeof txn.quantity !== "number" || isNaN(txn.quantity) || txn.quantity <= 0) {
                alert(`Row ${i + 1}: Quantity must be a valid positive number.`);
                return;
            }

            if (typeof txn.totalAmount !== "number" || isNaN(txn.totalAmount)) {
                alert(`Row ${i + 1}: Total Amount must be a valid number.`);
                return;
            }
        }

        //get contractNote number or generate if this is a new Demerger
        let manualNote = contractNoteDTO?.contractNote?.contractNoteNo || "";
        if (!isDisplayClick) {
            manualNote = await fetchManualContractNoteNo("DEMERGER-CNT-"); // ✅ Now we get the actual value
            //console.log("📌 manualContractNoteNo BEFORE using:", manualNote); // ❌ Logs empty array []
        }

        const formData = new FormData(formRef.current);

        // Construct ContractNoteDTO
        const newContractNote = {
            contractNote: {
                contractNoteNo: manualNote,
                clientId: clientId,
                symbol: demergedCompany,
                tradeDate: formData.get("date"),
                cnoteType: "DEMERGER",
                brokerName: "",
            },
            cnotesCharge: {
                contractNoteNo: "",
                securitiesTransactionTaxNetTotal: "",
                stampDutyNetTotal: "",
                gstTotal: "",
                payInPayOutObligationNetTotal: "",
                otherCharges: "",
                netAmountNetTotal: "",
            },
            transactions: demergedInto.map((item, idx) => ({  // ✅ Ensure transactions are formatted correctly
                type: "DemergerTransactionDTO",
                contractNoteNo: manualNote,
                clientId: clientId,
                symbol: item.script, // ✅ Set symbol from demergedInto
                isin: "",
                quantity: item.quantity, // ✅ Set quantity from demergedInto
                weightedAvgPrice: item.totalAmount / item.quantity, // ✅ Derived value
                totalValue: item.totalAmount, // ✅ Set totalValue from demergedInto
                netQuantity: item.quantity, // ✅ Set netQuantity from demergedInto
                tradeDate: formData.get("date"),
                transactionType: "Demerger",
                beforeDemergerQuantity: beforeDemergerQuantity,
                /*beforeDemergerTotalAmount: beforeDemergerTotalAmount,*/
                beforeDemergerTotalAmount: 0,  //we aren't using this field
                demergerDetails: {  // ✅ Keep demergerDetails wrapped in an array
                    contractNoteNo: manualNote,
                    demergedFromSymbol: demergedCompany,
                    beforeDemergerQuantity: beforeDemergerQuantity,
                    /*beforeDemergerTotalAmount: beforeDemergerTotalAmount,*/
                    beforeDemergerTotalAmount: 0,  //we aren't using this field
                    tradeDate: formData.get("date"),
                    /*symbol: item.script,
                    isin: "",
                    quantity: item.quantity,
                    totalAmount: item.totalAmount,*/
                },
            })),
            cnoteType: "DEMERGER"
        };

        try {
            const result = await saveContractNote(newContractNote, isDisplayClick); // Wait for save to complete
            if (result.success) {
                refreshPFdata(); // ✅ Now refreshes AFTER the save is successful
                onClose(); // Close the popup after successful Save
            }
        } catch (error) {
            console.error("Error saving Demerger:", error);
        }
    };

    const handleAddRow = async (type) => {
        setDemergedInto(prev => [...prev, {script: "", quantity: 0, totalAmount: 0}]);

    };

    // ✅ Handles changes in the input fields (Script Name, Quantity, Total Amount)
    const handleInputChange = (index, field, value) => {
        setDemergedInto(prev =>
            prev.map((txn, idx) =>
                idx === index ? {...txn, [field]: value} : txn
            )
        );
    };
    // ✅ Handles row removal
    const handleRemoveRow = (index) => {
        setDemergedInto(prev => prev.filter((_, idx) => idx !== index));
    };

    const handleDelete = async () => {
        try {
            const result = await deleteContractNote(contractNoteDTO.contractNote.contractNoteNo); // Wait for save to complete
            if (result.success) {
                refreshPFdata(); // ✅ Now refreshes AFTER the save is successful
                onClose(); // Close the popup after successful Save
            }
        } catch (error) {
            console.error("Error deleting Demerger:", error);
        }
    };


    return (
        <div className="demerger-overlay" onClick={onClose}>
            <form ref={formRef}>
                <div className="demerger-popup" onClick={(e) => e.stopPropagation()}>

                    <h3>Stock D'Merger</h3>

                    <div className="form-group">
                        <label className="general-label">Asset Name:</label>
                        <input
                            type="string"
                            value={demergedCompany}
                            disabled
                        />
                    </div>

                    <div className="form-group">
                        <label className="general-label">Date:</label>
                        <input name="date" type="date" value={date} onChange={(e) => setDate(e.target.value)}/>
                    </div>

                    <div className="form-group">
                        <label className="general-label">Bal. Quantity before D'Merger:</label>
                        <input
                            type="string"
                            value={(beforeDemergerQuantity ?? 0).toLocaleString()}
                            disabled
                        />
                    </div>

                    {/*<div className="form-group">
                        <label className="general-label">Total Value before D'Merger:</label>
                        <input
                            type="string"
                            value={(beforeDemergerTotalAmount ?? 0).toLocaleString()}
                            disabled
                        />
                    </div>*/}
                    <div className="transaction-container">
                        <div className="transaction-header">
                            <h5>D'Merger Details:</h5>
                            <div className="small-buttons">
                                <button type="button" className="new-button" onClick={() => handleAddRow("buy")}>New
                                </button>
                            </div>
                        </div>
                        <table className="contract-table demerger-table">
                            <thead>
                            <tr>
                                <th>Script Name</th>
                                <th>Quantity</th>
                                <th>Total Amount</th>
                                <th></th>
                            </tr>
                            </thead>
                            <tbody>
                            {demergedInto.map((txn, idx) => (
                                <tr key={idx}>
                                    <td>
                                        <input
                                            type="text"
                                            value={txn.script}
                                            placeholder="Enter script name"
                                            onChange={(e) => handleInputChange(idx, "script", e.target.value)}
                                        />
                                    </td>
                                    <td>
                                        <input
                                            type="number"
                                            value={txn.quantity}
                                            min="1"
                                            onChange={(e) => handleInputChange(idx, "quantity", parseFloat(e.target.value) || 0)}
                                        />
                                    </td>
                                    <td>
                                        <input
                                            type="number"
                                            value={txn.totalAmount}
                                            min="1"
                                            onChange={(e) => handleInputChange(idx, "totalAmount", parseFloat(e.target.value) || 0)}
                                        />
                                    </td>
                                    <td>
                                        <button type="button" className="cross-button"
                                                onClick={() => handleRemoveRow(idx)}>❌
                                        </button>
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                        </table>
                    </div>


                        <div className="contract-buttons">
                            {isDisplayClick && (
                                <button type="button" className="delete-button" onClick={handleDelete}>
                                    Delete CNote
                                </button>
                            )}
                            <div className="right-buttons">
                                <button type="button" className="save-button" onClick={handleSave}>Save</button>
                                <button type="button" className="cancel-button" onClick={handleClose}>Cancel</button>
                            </div>
                        </div>
                    </div>
            </form>
        </div>
)
;
};

export default Demerger;
